// Скелетоны вместо полноэкранного спиннера (§6).
// Source: docs/specs/design-revision/d-design-system.md §6.
//
// `FullScreenSpinner` на каждом переходе даёт мигание в пустоту: экран
// схлопывается в одну строку «Загрузка…», а через полсекунды разворачивается
// обратно. Там, где структура будущего содержимого известна заранее, показываем
// её форму. Там, где не известна (ошибка, пустое состояние), спиннер остаётся —
// скелетон под неизвестное содержимое обещал бы то, чего может не быть.

import { cn } from '@/lib/utils';

function Bone({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-control bg-muted', className)} aria-hidden="true" />;
}

/** Обёртка: одна точка объявления role/aria на все скелетоны. */
function Frame({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div role="status" aria-label="Загрузка" className={cn('space-y-3', className)}>
      {children}
    </div>
  );
}

/** Строка показателя — форма MarkerRow. */
export function MarkerRowSkeleton() {
  return (
    <div className="flex items-start gap-3 rounded-surface border border-border bg-surface p-3.5">
      <div className="min-w-0 flex-1 space-y-1.5">
        <Bone className="h-3.5 w-2/5" />
        <Bone className="h-3 w-3/5" />
      </div>
      <Bone className="h-6 w-14" />
    </div>
  );
}

/** Главная: сводка и три строки. */
export function HomeSkeleton() {
  return (
    <Frame className="px-4 pt-3">
      <Bone className="h-5 w-1/2" />
      <div className="rounded-surface border border-border bg-surface p-4">
        <Bone className="mb-3 h-4 w-1/3" />
        <div className="flex items-end gap-3">
          <Bone className="h-12 flex-1" />
          <Bone className="h-8 flex-1" />
          <Bone className="h-16 flex-1" />
          <Bone className="h-6 flex-1" />
        </div>
      </div>
      <MarkerRowSkeleton />
      <MarkerRowSkeleton />
      <MarkerRowSkeleton />
    </Frame>
  );
}

/** Каталог: три свёрнутые категории. */
export function CatalogSkeleton() {
  return (
    <Frame className="px-4 pt-2">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center gap-3 rounded-surface border border-border bg-surface p-3.5">
          <Bone className="h-3 w-3 rounded-full" />
          <Bone className="h-3.5 flex-1" />
          <Bone className="h-4 w-8" />
        </div>
      ))}
    </Frame>
  );
}

/** Карточка показателя: блок значения и место под график. */
export function BiomarkerDetailSkeleton() {
  return (
    <Frame className="px-4 pt-3">
      <div className="rounded-surface border border-border bg-surface p-4">
        <Bone className="mb-2 h-4 w-2/5" />
        <Bone className="mb-3 h-8 w-1/3" />
        <Bone className="h-3 w-3/5" />
      </div>
      <Bone className="h-40 w-full rounded-surface" />
    </Frame>
  );
}
